import {Injectable} from '@angular/core';
import {FormbirdInjectorService} from 'formbird-services';
const logger = console;
@Injectable({
  providedIn: 'root'
})
export class SclUtilValidationService {

  constructor(private formbirdInjectorService: FormbirdInjectorService) {
    this.documentModalService = this.formbirdInjectorService.get('DocumentModalService');
  }
  private documentModalService: any;

  getValidatorObj(dataFields) {
    const validationObj = {validationFunc: null, name: null, validationMsg: null};
    if (this.hasValue(dataFields) && dataFields.fieldValidator &&
      dataFields.fieldValidator.validationFunc && dataFields.fieldValidator.validationMsg) {

      // disable warning about use of Function. This is because using dynamically loaded code isn't seen as a good thing.
      // we're doing it to load the code from the template but wouldn't do it for normal file scripts
      /* jshint -W054 */
      validationObj.validationFunc = new Function('value', dataFields.fieldValidator.validationFunc);
      /* jshint +W054 */

      validationObj.validationMsg = dataFields.fieldValidator.validationMsg;
      validationObj.name = dataFields.fieldValidator.name;
    }
    return validationObj;
  }

  hasValidateFunc(field) {
    const validateObj = this.getValidatorObj(field);
    return !!validateObj.validationFunc;
  }

  validateFieldValue(field) {
    let res = false;
    const validateObj = this.getValidatorObj(field);
    if (validateObj.validationFunc && field.fieldValue) {
      const validatorFunc = validateObj.validationFunc;
      res = validatorFunc(field.fieldValue);
    }
    return res;
  }

  /*
   * Validate field value, if the validation get errors, the validator name will be returned. Otherwise, return null.
   */
  validateField(validator, newValue) {
    let res = true;
    if (validator.validationFunc) {
      const validatorFunc = validator.validationFunc;
      res = validatorFunc(newValue);
    }
    return res === false ? validator.name : null;

  }

  hasValue(val) {
    return val !== null && typeof(val) !== 'undefined' && val !== '';
  }

  validateMinLength(val, minLength) {
    return this.hasValue(val) && val.length >= minLength;
  }
  validateMaxLength(val, maxLength) {
    return !val || this.hasValue(val) && val.length <= maxLength;
  }

  restrictAccess(keyIds, userAccessKey) {
    if (!keyIds || keyIds.length === 0) {
      return true;
    }

    for (let idx = 0; idx < userAccessKey.length; idx++) {
      for (let id = 0; id < keyIds.length; id++) {
        // logger.debug('Approve Component Access Key ' + keyIds[id] + ' == ' + userAccessKey[idx]);
        if (userAccessKey[idx] === keyIds[id]) {
          logger.debug('Access Key Match ' + keyIds[id]);
          return keyIds;
        }
      }
    }

    logger.debug('User has no key to access approve field.');
    return null;
  }
  checkAccess(keyIds, user, operation) {
    const userAccessKeys = [];
    if (user.accessKeys) {
      for (let i = 0; i < user.accessKeys.length; i++) {
        const accessKey = user.accessKeys[i];
        if (accessKey.rights) {
          for (let j = 0; j < accessKey.rights.length; j++) {
            if (operation === accessKey.rights[j]) {
              if (accessKey.keyId) {
                userAccessKeys.push(accessKey.keyId);
                // logger.debug('Approve User Valid Keys '+accessKey.keyId);
              }
            }
          }
        }
      }
    }
    const result = this.restrictAccess(keyIds, userAccessKeys);
    return result !== null;
  }

}

